import { render, staticRenderFns } from "./transmitir.vue?vue&type=template&id=9ac3515e&"
import script from "./transmitir.vue?vue&type=script&lang=js&"
export * from "./transmitir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports